import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import { CoachAvailabilityDto } from "../../../models/coach/dto/coach-availability.dto";
import { SetCoachAvailabilitiesInputDto } from "../../../models/coach/dto/set-coach-availabilities.dto";
import { ALL_COACH_CALENDAR_QUERY_KEY } from "./useGetCoachCalendar";

export const useSetCoachAvailabilities = (coachId: string, onSuccess: () => void) => {
    const apiClient = useApiClient();
    const queryClient = useQueryClient();
    return useMutation({
        mutationKey: ['set-coach-availabilities', coachId],
        mutationFn: (input: SetCoachAvailabilitiesInputDto) => apiClient.fetchApi<CoachAvailabilityDto[], SetCoachAvailabilitiesInputDto>({ endpoint: `coachs/${coachId}/availabilities`, method: 'POST', body: input }),
        onSuccess: () => {
            queryClient.invalidateQueries(ALL_COACH_CALENDAR_QUERY_KEY(coachId));
            onSuccess();
        }
    });
};